import * as React from 'react';
import { cn } from '@/lib/utils';

const Input = React.forwardRef(({ className, type, ...props }, ref) => (
  <input
    type={type}
    className={cn(
      'flex h-8 w-full rounded-md border border-border bg-background px-3 py-1 text-sm text-foreground shadow-none transition-colors',
      'placeholder:text-muted-foreground',
      'focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring',
      'disabled:cursor-not-allowed disabled:opacity-50',
      // Remove browser number spinners
      '[[type=number]]:[-moz-appearance:textfield]',
      '[&[type=number]]::[&::-webkit-outer-spin-button]:appearance-none',
      '[&[type=number]]::[&::-webkit-inner-spin-button]:appearance-none',
      className
    )}
    ref={ref}
    {...props}
  />
));
Input.displayName = 'Input';

export { Input };
